export default "__VITE_ASSET__DrHnGzuP__"